<div class="container p-3">
    <div class="row">
        <div class="col">
            <h3>Search users</h3>
            <div class="mb-3">
                <div class="input-group">
                    <input #userSearchInput type="text" placeholder="Search users..." class="form-control" maxlength="256" (keyup.enter)="searchUser(userSearchInput.value)">
                    <button class="btn btn-primary" (click)="searchUser(userSearchInput.value)">
                        <i class="fas fa-search"></i> Search
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div>
        <div *ngIf="mykronozAccounts || tooMany">
            <div>
                <h5>MyKronoz Account</h5>
            </div>
            <div *ngIf="mykronozAccounts?.length == 0">
                No results...
            </div>
            <div *ngIf="tooMany">
                Too many results...
            </div>
            <div *ngFor="let mykronozAccount of mykronozAccounts">
                <div class="row background-hover py-1" *ngIf="mykronozAccount.id">
                    <div class="col-2">
                        <button class="btn btn-sm btn-outline-primary" [routerLink]="['/users', mykronozAccount.id]">
                            <i class="fas fa-user-edit"></i> Open
                        </button>
                    </div>
                    <div class="col-3" *ngIf="mykronozAccount.id">
                        <a class="d-block text-truncate" [routerLink]="['/users', mykronozAccount.id]">
                            <code>#{{ mykronozAccount.id }}</code>
                        </a>
                    </div>
                    <div class="col-5" *ngIf="mykronozAccount.email">
                        <a class="d-block text-truncate" href="mailto:{{ mykronozAccount.email }}">
                            <ng-container *ngIf="mykronozAccount.nickname != null && mykronozAccount.nickname != mykronozAccount.firstname; then thenBlock; else elseBlock"></ng-container>
                            <ng-template #thenBlock>
                                "{{ mykronozAccount.firstname }} {{ mykronozAccount.lastname }} ({{ mykronozAccount.nickname }})" &lt;{{ mykronozAccount.email }}&gt;
                            </ng-template>
                            <ng-template #elseBlock>
                                "{{ mykronozAccount.firstname }} {{ mykronozAccount.lastname }}" &lt;{{ mykronozAccount.email }}&gt;
                            </ng-template>
                        </a>
                    </div>
                    <div class="col-5" *ngIf="!mykronozAccount.email">
                        <span class="d-block text-truncate">
                            <ng-container *ngIf="mykronozAccount.nickname != null && mykronozAccount.nickname != mykronozAccount.firstname; then thenBlock; else elseBlock"></ng-container>
                            <ng-template #thenBlock>
                                {{ mykronozAccount.firstname }} {{ mykronozAccount.lastname }} ({{ mykronozAccount.nickname }})
                            </ng-template>
                            <ng-template #elseBlock>
                                {{ mykronozAccount.firstname }} {{ mykronozAccount.lastname }}
                            </ng-template>
                        </span>
                    </div>
                    <div class="col-2 text-end">
                        <button class="btn btn-sm btn-outline-danger" (click)="displayDeleteUser(mykronozAccount.id)" *ngIf="!deleteUserVisible[mykronozAccount.id]">
                            <i class="fas fa-trash-alt"></i> Delete
                        </button>
                        <button class="btn btn-sm btn-danger" (click)="deleteUser(mykronozAccount.id)" *ngIf="deleteUserVisible[mykronozAccount.id]">
                            <i class="fas fa-exclamation-circle"></i> Confirm
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <hr>
        <div class="row" *ngIf="legacyAccounts && legacyAccounts.length > 0">
            <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2" *ngFor="let legacyAccount of legacyAccounts">
                <div>
                    <h5>{{ legacyAccount.product }}</h5>
                </div>
                <div *ngIf="legacyAccount.data">
                    <div *ngIf="legacyAccount.data.length == 0">
                        <hr class="my-1">
                        No results...
                    </div>
                    <div class="pb-5" *ngIf="legacyAccount.data.length > 0">
                        <div *ngFor="let email of legacyAccount.data">
                            <hr class="my-1">
                            <div class="background-hover">
                                <span class="d-block text-truncate">{{ email }}</span>
                                <div>
                                    <button class="btn btn-sm btn-outline-danger" (click)="displayDeleteLegacyAccount(legacyAccount.product, email)" *ngIf="!deleteLegacyAccountVisible[legacyAccount.product][email]">
                                        <i class="fas fa-trash-alt"></i> Delete
                                    </button>
                                    <button class="btn btn-sm btn-danger" (click)="deleteLegacyAccount(legacyAccount.product, email)" *ngIf="deleteLegacyAccountVisible[legacyAccount.product][email]">
                                        <i class="fas fa-exclamation-circle"></i> Confirm
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="!legacyAccount.data">
                    <div>Error... </div>
                    <div *ngIf="legacyAccount.error?.message">({{ legacyAccount.error?.message }})</div>
                </div>
            </div>
        </div>
    </div>
    <hr>
    <div class="row">
        <div class="col">
            <h3>Data migration (v1)</h3>
            <div class="mb-3">
                <div class="form-check form-check-inline">
                    <label class="form-check-label">From&nbsp;</label>
                    <input #accountIdSrc type="text" placeholder="Account ID" maxlength="20" class="form-control" (keyup.enter)="reviewDataMigration(accountIdSrc.value, accountIdDst.value)">
                </div>
                <div class="form-check form-check-inline">
                    <label class="form-check-label">To&nbsp;</label>
                    <input #accountIdDst type="text" placeholder="Account ID" maxlength="20" class="form-control" (keyup.enter)="reviewDataMigration(accountIdSrc.value, accountIdDst.value)">
                </div>
                <div class="form-check form-check-inline">
                    <button class="btn btn-outline-primary" (click)="reviewDataMigration(accountIdSrc.value, accountIdDst.value)">
                        <i class="fas fa-ellipsis-h"></i> Review
                    </button>
                </div>
            </div>
            <div *ngIf="src.account && dst.account">
                <div>
                    <strong>Copy tracking and sleep data...</strong>
                </div>
                <div class="float-start px-3 py-1">
                    <strong>...from:</strong>
                    <div>Account ID: <a [routerLink]="['/users', src.account.id]"><code>#{{ src.account.id }}</code></a></div>
                    <div>Email: {{ src.account?.account_detail?.email }}</div>
                    <div>Firstname: {{ src.account?.account_detail?.first_name }}</div>
                    <div>Lastname: {{ src.account?.account_detail?.last_name }}</div>
                    <div>Nickname: {{ src.personal?.personal?.nickname }}</div>
                </div>
                <div class="float-start px-3 py-1">
                    <strong>...to:</strong>
                    <div>Account ID: <a [routerLink]="['/users', dst.account.id]"><code>#{{ dst.account.id }}</code></a></div>
                    <div>Email: {{ dst.account?.account_detail?.email }}</div>
                    <div>Firstname: {{ dst.account?.account_detail?.first_name }}</div>
                    <div>Lastname: {{ dst.account?.account_detail?.last_name }}</div>
                    <div>Nickname: {{ dst.personal?.personal?.nickname }}</div>
                </div>
                <div class="clearfix">
                </div>
                <div *ngIf="!dataMigrationSuccess">
                    <div class="mb-1"><i class="fas fa-info-circle"></i> Source account data will not be changed.</div>
                    <div class="mb-1"><i class="fas fa-info-circle"></i> Destination account data will not be overwritten if it exists.</div>
                    <div class="mb-1">
                        <button class="btn btn-primary" (click)="queueDataMigration(src.account.id, dst.account.id)">
                            Confirm
                        </button>
                    </div>
                </div>
            </div>
            <div *ngIf="src.error">
                Account not found: {{ accountIdSrc.value }}
            </div>
            <div *ngIf="dst.error">
                Account not found: {{ accountIdDst.value }}
            </div>
            <div *ngIf="dataMigrationSuccess">
                <i class="fas fa-check-circle"></i> Success. Data migration will be completed in a few minutes.
            </div>
        </div>
    </div>
</div>